import React from "react";
import DialogBox from "../../../../../components/DialogBox";

interface UpdateWarningProps {
  readonly isOpen: boolean;
  readonly close: () => void;
  readonly onSubmit: () => void;
  readonly messages: string[];
}

const UpdateWarning = ({
  isOpen,
  close,
  onSubmit,
  messages,
}: UpdateWarningProps) => (
  <DialogBox
    onCancel={close}
    open={isOpen}
    onConfirm={onSubmit}
    acceptButtonText="Confirm"
    declineButtonText="Cancel"
  >
    {messages
      .map((message, index) => ({ id: index, message }))
      .map(({ id, message }) => (
        <p key={id}>{message}</p>
      ))}
  </DialogBox>
);

export default UpdateWarning;
